export const bike = {

  namespaced: true,

  state: {
    totalBikes: 0,
    bike: {}
  },

  actions: {
    query({commit}, payload) {
      commit('updateQuery', payload);
    },
    storeBike({commit}, payload) {
      commit('updateBike', payload)
    }
  },

  mutations: {
    updateQuery(state, payload) {
      state.totalBikes = payload
    },

    updateBike(state, payload) {
        state.bike = payload
    }
  }
};
